import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AuthenticatedGuard } from '../shared/guards/authenticated.guard';
import { CustomerComponent } from './customer/customer.component';
import { CustomersComponent } from './customers/customers.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ImportCustomersComponent } from './import-customers/import-customers.component';
import { InviteComponent } from './invite/invite.component';
import { NewCustomerComponent } from './new-customer/new-customer.component';
import { OrganisationComponent } from './organisation.component';
import { PreferencesComponent } from './preferences/preferences.component';
import { StaffListComponent } from './staff-list/staff-list.component';
import { StaffComponent } from './staff/staff.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'organisations/:organisationId',
        component: OrganisationComponent,
        canActivate: [AuthenticatedGuard],
        children: [
          { path: '', component: DashboardComponent },
          { path: 'team', component: StaffListComponent },
          { path: 'team/invite', component: InviteComponent },
          { path: 'team/invite/:mode', component: InviteComponent },
          { path: 'team/:id', component: StaffComponent },
          { path: 'customers', component: CustomersComponent },
          { path: 'customers/new', component: NewCustomerComponent },
          { path: 'customers/import', component: ImportCustomersComponent },
          { path: 'customers/:customerId', component: CustomerComponent },
          { path: 'communities', component: CustomersComponent },
          { path: 'communities/new', component: NewCustomerComponent },
          { path: 'communities/import', component: ImportCustomersComponent },
          { path: 'communities/:customerId', component: CustomerComponent },
          { path: 'preferences', component: PreferencesComponent }
        ]
      }
    ])
  ],
  exports: [RouterModule]
})
export class OrganisationRoutingModule {}
